import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "results", "selectedLabel", "otherPersonId", "mode"]

  connect() {
    this.clear()
  }

  clear() {
    if (this.hasResultsTarget) this.resultsTarget.innerHTML = ""
    if (this.hasSelectedLabelTarget) this.selectedLabelTarget.textContent = "None"
    if (this.hasOtherPersonIdTarget) this.otherPersonIdTarget.value = ""
  }

  async search() {
    const q = this.queryTarget.value.trim()

    if (!q) {
      this.resultsTarget.innerHTML = ""
      return
    }

    const resp = await fetch(`/people/search?q=${encodeURIComponent(q)}`, {
      headers: { Accept: "application/json" }
    })

    if (!resp.ok) {
      this.resultsTarget.innerHTML = `<div class="text-danger small">Search failed</div>`
      return
    }

    const people = await resp.json()
    this.renderResults(people)
  }

  renderResults(people) {
    if (!people.length) {
      this.resultsTarget.innerHTML = `<div class="text-muted small">No matches</div>`
      return
    }

    this.resultsTarget.innerHTML = people.map((p) => {
      const label = p.name || `Person #${p.id}`
      const dates = p.life_dates || ""
      const meta = dates
        ? ` <span class="text-muted small">(${this.escapeHtml(dates)})</span>`
        : ""

      return `
        <button type="button"
                class="list-group-item list-group-item-action"
                data-action="click->person-relationships#pick"
                data-person-id="${p.id}"
                data-person-label="${this.escapeHtml(label)}">
          ${this.escapeHtml(label)}${meta}
        </button>
      `
    }).join("")
  }

  pick(e) {
    const btn = e.currentTarget
    const id = btn.dataset.personId
    const label = btn.dataset.personLabel

    this.otherPersonIdTarget.value = id
    this.selectedLabelTarget.textContent = `${label} (#${id})`
  }

  escapeHtml(str) {
    return (str || "").replace(/[&<>"']/g, (m) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      "\"": "&quot;",
      "'": "&#039;"
    }[m]))
  }
}